import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class TicketFieldExpandService {

    constructor(){

        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);
        
        this.TICKET_FIELD_EXPAND = '/api/ticket-field-expand';
        this.GET_LIST_FILTERED = '/list/filtered';
        this.GET_TICKET_BY_TICKET_ID = '/ticket/{ticketId}';
        this.GET_TICKET_LIST_BY_USER_ID = '/user/{userId}';
        this.GET_TICKET_LIST_BY_EMAIL = '/email/{email}';
        this.GET_TICKETS_STATS_BY_USER_ID = '/stats/user/{userId}';
    }

    async getListFiltered(filterMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET_FIELD_EXPAND + this.GET_LIST_FILTERED;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getTicketByTicketId(ticketId) {
        try {
            let url = window.location.origin + this.TICKET_FIELD_EXPAND + this.GET_TICKET_BY_TICKET_ID;
            url = url
                .replace('{ticketId}', ticketId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketListByUserId(userId) {
        try {
            let url = window.location.origin + this.TICKET_FIELD_EXPAND + this.GET_TICKET_LIST_BY_USER_ID;
            url = url
                .replace('{userId}', userId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketStatsByUserId(userId) {
        try {
            let url = window.location.origin + this.TICKET_FIELD_EXPAND + this.GET_TICKETS_STATS_BY_USER_ID;
            url = url
                .replace('{userId}', userId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

}

export default TicketFieldExpandService;
